import { LitElement } from 'lit';

export abstract class ClassComponent extends LitElement {
   abstract get _classesStartingWith(): string[];

   abstract get _classesContaining(): string[];

   abstract _buildClassList(classList: string[]): void;

   protected override createRenderRoot() {
      return this;
   }

   override updated() {
      let classNames = this.classList.value.split(' ');
      classNames = classNames.filter((c) => {
         if (this._classesStartingWith.some((prefix) => c.startsWith(prefix))) {
            return false;
         }
         if (
            this._classesContaining.some((substring) => c.includes(substring))
         ) {
            return false;
         }
         return true;
      });
      this._buildClassList(classNames);
      this.classList.value = classNames.join(' ');
   }
}
